export default "__VITE_ASSET__e8381139__"